import React from 'react';
import PropTypes from 'prop-types';
import Actions from './Actions';
import TopMenu from './TopMenu';

class Header extends React.Component {
  render() {
    return (
      <header className="page-header navbar navbar-fixed-top">
        <div className="page-header-inner">
          <div className='row'>
            <Actions/>
            <TopMenu profile={this.props.userProfile}/>
          </div>
        </div>
      </header>
    );
  }
}

Header.propTypes = {
  userProfile: PropTypes.object,
};

export default Header;
